import React, { Component } from "react";
import {Typography, Button, Spin} from "antd";
import OtpInput from "react-otp-input";

import {displayError, displayGenericError} from "common/notifications";
import {
  submitOTP,
  getCurrentCustomer,
  getOTP,
  submitPhoneNumber
} from "api/api";
import PhoneVerificationIcon from "icons/PhoneVerificationIcon";
import EnterPhoneNumberLayout from "components/EnterPhoneNumberLayout";
import OkModal from "components/modal/OkModal";
import "./EnterOTPLayout.scss";
import withUseIntl from "./withUseIntl";
import {createOTPEmail} from "../api/api";

const { Text } = Typography;

class EnterOTPLayout extends Component {
  state = {
    phoneNumber: "",
    otp: "",
    resendOtp: false,
    minutesCountdown: 5,
    secondsCountdown: 0,
    showChangePhoneNumber: false,
    visible: false,
    customerStatus: "",
    customer: null,
    loadingSendOtpEmail:false,
    useAuthyTotp:false
  };

  componentDidMount() {
    this.countDown();
    this.getCustomer();
  }

  componentWillReceiveProps() {
    this.getCustomer();
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  getCustomer = () => {
    const { customer } = this.props;
    if (customer) {
      this.setState({
        phoneNumber: customer.phone || "",
        email:customer.email,
        customerStatus: customer.status,
        useAuthyTotp: customer.useAuthyTotp
      });
    } else {
      getCurrentCustomer()
        .then(response => {
          this.setState({
            phoneNumber: response.phone || "",
            email:response.email,
            customerStatus: response.status,
            useAuthyTotp: response.useAuthyTotp
          });
        })
        .catch(displayGenericError);
    }
  };

  countDown() {
    this.interval = setInterval(() => {
      let { secondsCountdown, minutesCountdown } = this.state;

      if (secondsCountdown > 0) {
        secondsCountdown = secondsCountdown - 1;
      }

      if (secondsCountdown === 0 && minutesCountdown > 0) {
        secondsCountdown = 59;
        minutesCountdown = minutesCountdown - 1;
      }

      if (secondsCountdown === 0 && minutesCountdown === 0) {
        if (this.interval) clearInterval(this.interval);
      }

      this.setState({
        minutesCountdown,
        secondsCountdown
      });
    }, 1000);
  }

  maskPhone = phoneNumber => {
    const phoneNumberWithoutCountryCode = phoneNumber.split(" ")[0];
    return phoneNumberWithoutCountryCode
      .substring(0, phoneNumberWithoutCountryCode.length - 3)
      .replace(/./g, "x")
      .concat(
        phoneNumberWithoutCountryCode.slice(
          phoneNumberWithoutCountryCode.length - 3
        )
      );
  };

  maskEmail = email => {
    const emailArr = email.split("@");
    let length = emailArr[0].length;
    let start = emailArr[0].substr(0, 1);
    let end = emailArr[0].substr(length-2);
    let encodeEmail = start + "***" + end +'@'+ emailArr[1];
    return encodeEmail;
  };

  addZero(number) {
    return number.toString().length === 1 ? `0${number}` : number;
  }

  handleVerifyOTP = () => {
    const { verifyOTP } = this.props;
    if (verifyOTP) {
      verifyOTP(this.state.otp);
    } else {
      submitOTP(this.state.otp)
        .then(response => {
          if (response.result === "success") {
            window.location = "/";
          } else {
            displayGenericError({ message: response.result });
          }
        })
        .catch(displayGenericError);
    }
  };

  sendOTPEmail = () => {
    this.setState({
      loadingSendOtpEmail: true,
    })
    createOTPEmail(this.props.customer).then(res => {
      if(res==true) {
        clearInterval(this.interval);
        setTimeout(() => {
          this.setState({
            loadingSendOtpEmail: false,
            minutesCountdown: 5,
            secondsCountdown: 0
          }, () => {
            this.countDown();
          })
        }, 2000)
      }else {
        displayGenericError();
      }
    }).catch(e => {
      displayError(e.message);
    })


  }

  onChangePhoneNumberHandler = () => {
    this.setState({ visible: true });
  };

  handleOk = () =>
    this.setState({ showChangePhoneNumber: true, visible: false });

  handleProceed = ({ phoneNumber, countryCode }) => {
    submitPhoneNumber(
      {
        phone: phoneNumber,
        country: countryCode
      },
      this.props.token
    )
      .then(() => {
        if (this.props.token) {
          getCurrentCustomer(this.props.token)
              .then(response => {
                this.setState({
                  phoneNumber: response.phone || "",
                  customerStatus: response.status
                });
              })
              .catch(displayGenericError);
          this.setState({showChangePhoneNumber: false});
        } else {
          window.location = "/"
        }
      })
      .catch(displayGenericError);
  };


  resendOTP = () => {
    getOTP(this.props.token)
      .then(() => {
        this.setState({ secondsCountdown: 0, minutesCountdown: 2, otp: "" });
        this.countDown();
      })
      .catch(displayGenericError);
  };
  generateAuthyQRCode = () =>{
    this.props.generateAuthyQRCode()

  }
  render() {
    const disabled = this.state.otp.length < 6;
    const intl = this.props.useIntl;

    return (
      <div className="opt-layout-wrapper verify-page-modal">
        <div className="inner-content">
          {!this.state.showChangePhoneNumber && (
            <>
              <span className="svg-icon">
                <PhoneVerificationIcon />
              </span>
              <h2 className="fw-700">{intl.formatMessage({id:"app.page.enterotplayout.otpisrequired"})}</h2>
              {!this.state.useAuthyTotp && (
                <p className="describe">
                  {intl.formatMessage({id:"app.page.enterotplayout.text.send.to"})} {" "}
                  <b style={{letterSpacing: 1.4}}>{this.maskPhone(this.state.phoneNumber)}</b>
                </p>
                )}
              {this.state.useAuthyTotp && (
                  <p className="describe">
                    {intl.formatMessage({id:"app.page.enterotplayout.text.totp.message"})} {" "}

                  </p>
              )}
              <br/>
              
              {this.state.email && (
                <>
                  {!this.state.useAuthyTotp && (
                <p className="describe">
                  {intl.formatMessage({id:"app.page.enterotplayout.or"})}
                  {" "}
                  {intl.formatMessage({id:"app.common.click"})}
                  {" "}
                {this.state.loadingSendOtpEmail ? <Spin /> : <a onClick={this.sendOTPEmail}>{intl.formatMessage({id:"app.common.here"})}</a>}
                  {" "}
                  {intl.formatMessage({id:"app.page.enterotplayout.send.to.email"})}
                  {" "}<b style={{letterSpacing: 0.8}}>{this.maskEmail(this.state.email)}</b>
                </p>
                 )}

                  {this.state.useAuthyTotp && (
                      <p className="describe">
                        {intl.formatMessage({id:"app.common.click"})}
                        {" "}
                        {this.state.loadingSendOtpEmail ? <Spin /> : <a onClick={this.sendOTPEmail}>{intl.formatMessage({id:"app.common.here"})}</a>}
                        {" "}
                        {intl.formatMessage({id:"app.page.enterotplayout.send.to.email"})}
                        {" "}<b style={{letterSpacing: 0.8}}>{this.maskEmail(this.state.email)}</b>
                      </p>
                  )}
                </>
              )}
              <span className="describe">
                  {intl.formatMessage({id:"app.common.click"})}
                  {" "}
                    <a onClick={this.generateAuthyQRCode}>{intl.formatMessage({id:"app.common.here"})}</a>
                {" "}
                to setup Authenticator app(eg. Authy, Google Authenticator, Microsoft Authenticator etc)</span>
              <br/>
              <h3 className="fw-700">{intl.formatMessage({id:"app.page.enterotplayout.text.enter.code"})}</h3>
              <br/>
              <div className="otp-input-section">
                <OtpInput
                  shouldAutoFocus={true}
                  numInputs={6}
                  isInputNum={true}
                  containerStyle={{ height: "100%" }}
                  value={this.state.otp}
                  onChange={otp => this.setState({ otp },()=>{
                   if(this.state.otp.length === 6){
                     this.handleVerifyOTP()
                   }
                  })}
                />
              </div>
              <div className="count-down-section">
                <span className="count-down">
                  {this.addZero(this.state.minutesCountdown)}:
                  {this.addZero(this.state.secondsCountdown)}
                </span>
                {this.state.customerStatus === "PHONE_VERIFICATION_REQUIRED" && (
                  <Button
                    type = "link"
                    onClick={this.onChangePhoneNumberHandler}
                  >
                    &nbsp;Change phone number
                  </Button>
                )}
              </div>
              <div className="buttons-section">
                <Button
                  type="primary"
                  className="btn-wide-md"
                  disabled={disabled}
                  onClick={this.handleVerifyOTP}
                >
                  {intl.formatMessage({id:"app.page.enterotplayout.verify"})}
                </Button>
                {this.state.minutesCountdown === 0 &&
                  this.state.secondsCountdown === 0 && (
                    <Text style={{marginLeft: '5px',cursor:"pointer"}}
                      onClick={this.resendOTP}
                      className="change-phone-number"
                    >
                      {intl.formatMessage({id:"app.page.enterotplayout.resend.code"})}
                    </Text>
                  )}
              </div>
            </>
          )}
          {this.state.showChangePhoneNumber && (
            <EnterPhoneNumberLayout proceedHandler={this.handleProceed} />
          )}
          <OkModal
            message= {intl.formatMessage({id: "app.page.enterotplayout.ok.msg.change.phone"})}
            visible={this.state.visible}
            handleOk={this.handleOk}
            title={intl.formatMessage({id:"app.page.enterotplayout.ok.change.phone.number"})}
          />
        </div>
      </div>
    );
  }
}

export default withUseIntl(EnterOTPLayout);
